import i18n from '@/i18n';

const $t = (text) => {
  return i18n.global.t(text);
};

export const performanceList = [
  {
    id: 'productName',
    text: $t('searchLabel.monTarget'),
    value: 'productName',
    width: 310,
    minWidth: 100,
    sortable: true,
    defaultValue: '',
    order: 1,
    isVisible: true,
    isFixed: true,
    fixed: 'left'
  },
  {
    id: 'vpnGatewayName',
    text: $t('searchLabel.vpnGatewayName'),
    value: 'vpnGatewayName',
    width: 130,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'attachmentType',
    text: $t('searchLabel.attachmentType'),
    value: 'attachmentType',
    width: 100,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'accessLocation',
    text: $t('searchLabel.accessLocation'),
    value: 'accessLocation',
    width: 100,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'saType',
    text: $t('searchLabel.saType'), //'인스턴스 유형',
    value: 'saType',
    width: 110,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'productIpAddress',
    text: $t('searchLabel.ip'), //'IP 주소',
    value: 'productIpAddress',
    width: 148,
    sortable: true,
    order: 2,
    isVisible: false
  },
  {
    id: 'dbVersion',
    text: $t('searchLabel.dbVersion'), // db 버전
    value: 'dbVersion',
    width: 240,
    sortable: true
  },
  {
    id: 'gpuClusterName',
    text: $t('searchLabel.gpuClusterName'), // gpu 클러스터명
    value: 'gpuClusterName',
    width: 130,
    sortable: true
  },
  {
    id: 'clusterName',
    text: $t('searchLabel.clusterName'), //클러스터명
    value: 'clusterName',
    width: 130,
    sortable: true
  },
  {
    id: 'queryEngineType',
    text: $t('searchLabel.queryEngineType'), //클러스터명
    value: 'queryEngineType',
    width: 130,
    sortable: true
  },
  {
    id: 'maxUsers',
    text: $t('searchLabel.maxUsers'),
    value: 'maxUsers',
    width: 130,
    sortable: true
  },
  {
    id: 'haType',
    text: $t('searchLabel.haType'), //노드타입
    value: 'haType',
    width: 130,
    sortable: true
  },
  {
    id: 'lbServiceName',
    text: $t('searchLabel.serviceName'), //'서비스명',
    value: 'lbServiceName',
    width: 180,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'lbServiceIp',
    text: $t('searchLabel.serviceIp'), //'서비스 IP',
    value: 'lbServiceIp',
    width: 145,
    sortable: true
  },
  {
    id: 'lbName',
    text: $t('searchLabel.lbName'), //'LB명',
    value: 'lbName',
    width: 180,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'lbSize',
    text: $t('searchLabel.lbSize'), //'LB명',
    value: 'lbSize',
    width: 140,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'vpcName',
    text: $t('searchLabel.vpcName'), //'LB명',
    value: 'vpcName',
    width: 240,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'connectedVPC',
    text: $t('searchLabel.connectedVPC'), //'연결VPC',
    value: 'connectedVPC',
    width: 240,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'serviceDomain',
    text: $t('searchLabel.productServiceDomain'), //'서비스도메인',
    value: 'serviceDomain',
    width: 130,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'nodeType',
    text: $t('searchLabel.nodeType'), //'노드 유형',
    value: 'nodeType',
    width: 130,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'type',
    text: $t('searchLabel.type'), //'노드 유형',
    value: 'type',
    width: 130,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'managerName',
    text: $t('searchLabel.dataOpsName'), //'dataOps명',
    value: 'managerName',
    width: 130,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'resourceName',
    text: $t('searchLabel.resourceName'),
    value: 'resourceName',
    width: 130,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'nodeCount',
    text: $t('searchLabel.hpcNodeCount'), //'노드 계산수',
    value: 'nodeCount',
    width: 130,
    sortable: false,
    bodyAlign: 'center'
  },
  {
    id: 'vmState',
    text: $t('searchLabel.vmState'), // vm상태
    value: 'vmState',
    width: 120,
    sortable: true
  },
  {
    id: 'productState',
    text: $t('searchLabel.productState'), // 성능수집 OR 상품 상태
    value: 'productState',
    width: 139,
    sortable: true,
    order: 3,
    isVisible: true
  },
  {
    id: 'productEventLevel',
    text: $t('searchLabel.eventLevel'), //'이벤트 위험도',
    value: 'productEventLevel',
    width: 125,
    sortable: true,
    bodyAlign: 'center',
    order: 4,
    isVisible: true
  },
  {
    id: 'diskType',
    text: $t('searchLabel.diskType'), //'이벤트 위험도',
    value: 'diskType',
    width: 125,
    sortable: true,
    bodyAlign: 'center',
  },
  {
    id: 'appVersion',
    text: $t('searchLabel.appVersion'),
    value: 'appVersion',
    width: 170,
    sortable: true,
    bodyAlign: 'center',
  },
  {
    id: 'nodePool',
    text: $t('searchLabel.nodePool'),
    value: 'nodePool',
    width: 170,
    sortable: true,
    bodyAlign: 'center',
  },
  {
    id: 'segmentName',
    text: $t('searchLabel.segmentName'),
    value: 'segmentName',
    width: 170,
    sortable: true,
    bodyAlign: 'center',
  }
];


export const performanceMetrics = [
  {
    id: 'Cluster GPU Memory Usage [Avg]',
    width: 230,
  },
  {
    id: 'Cluster GPU Count',
    width: 190,
  },
  {
    id: 'Cluster GPU Count In Use',
    width: 190,
  },
  {
    id: 'Cluster GPU Usage',
    width: 190,
  },
  {
    id: 'Network Out Bytes [Delta]',
    width: 210,
  },
  {
    id: 'Current Connection',
    width: 180,
  },
  {
    id: 'Connections [Current]',
    width: 180,
  },
  {
    id: 'Network Out Bytes',
    width: 180,
  },
  {
    id: 'Network in bytes',
    width: 180,
  },
  {
    id: 'Network In Packets [Unicast]',
    width: 222,
  },
  {
    id: 'Network Out Packets [Unicast]',
    width: 222,
  },
  {
    id: 'Cluster Nodes [Total]',
    width: 190,
  },
  {
    id: 'Cluster Namespaces [Total]',
    width: 202,
  },
  {
    id: 'Cluster Namespaces [Active]',
    width: 210,
  }
];